import openSocket from "socket.io-client";

const socket = openSocket("https://socket.eldocs.net/bxchat", {
  transports: ["websocket", "polling"]
});

export default socket;



// WEBPACK FOOTER //
// ./src/helpers/socket.js